import ReactEcharts from "echarts-for-react";
import { useTranslation } from "react-i18next";
import MaximizedPanelContainer from "../MaximizedPanelContainer";
import styles from "./index.module.less";

function RouteRange() {
  const { t } = useTranslation();
  return (
    <div className={`${styles.reactEchartContainer} panel-container`}>
      <MaximizedPanelContainer name={t("routeRangePanel")}>
        <ReactEcharts
          option={{
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
                shadowStyle: {
                  color: "rgba(0,0,0,0.08)",
                },
              },
              formatter: (params) => {
                const { name, value } = params[0];
                return `${name} : ${value}`;
              },
            },
            grid: {
              top: 15,
              left: 10,
              right: 10,
              bottom: 5,
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: true,
                axisLabel: {
                  color: "rgba(255,255,255,0.75)",
                  fontSize: 12,
                  lineHeight: 14,
                  end: true,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "rgba(255, 255, 255, 0.75)",
                  },
                },
                axisTick: {
                  show: true,
                  lineStyle: {
                    color: "rgba(255, 255, 255, 0.75)",
                  },
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "rgba(255, 255, 255, 0.35)",
                  },
                },
                data: [
                  "202106",
                  "202107",
                  "202108",
                  "202109",
                  "202110",
                  "202111",
                  "202206",
                  "202207",
                  "202208",
                  "202209",
                  "202210",
                  "202211",
                ],
              },
            ],
            yAxis: [
              {
                type: "value",
                axisLabel: {
                  color: "rgba(255,255,255,0.75)",
                  fontSize: 12,
                  lineHeight: 14,
                  end: true,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "rgba(255, 255, 255, 0.75)",
                  },
                },
                axisTick: {
                  show: true,
                  lineStyle: {
                    color: "rgba(255, 255, 255, 0.75)",
                  },
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "rgba(255, 255, 255, 0.35)",
                  },
                },
                min: 1,
                max: 31,
              },
            ],
            series: [
              {
                name: "Number",
                type: "bar",
                itemStyle: {
                  color: (params) => {
                    let colorList = [
                      "#1a7ab6",
                      "#f77d0e",
                      "#2a9c2a",
                      "#da2325",
                      "#9367bc",
                      "#8e5645",
                      "#e774bf",
                      "#808080",
                      "#bbba2c",
                      "#4A235A",
                      "#C39BD3",
                      "#F9E79F",
                      "#BA4A00",
                      "#ECF0F1",
                      "#616A6B",
                      "#EAF2F8",
                      "#4A235A",
                      "#3498DB",
                    ];
                    return colorList[params.dataIndex];
                  },
                },
                label: {
                  show: true,
                  position: "inside",
                  color: "rgba(255,255,255,0.75)",
                  fontSize: 12,
                },
                barWidth: 24,
                data: [0, 5, 31, 30, 28, 0, 0, 18, 31, 30, 13, 0],
              },
            ],
          }}
          lazyUpdate={true}
          style={{
            height: "100%",
            width: "100%",
          }}
        />
      </MaximizedPanelContainer>
    </div>
  );
}

export default RouteRange;
